import { isNumberString, isDefined } from "../../shared/utils";
import { FLATCOLOR, INVALID_1000, STEEPCOLOR } from "./consts";
const fs = window.require("fs");
const path = window.require("path");
export const isDataNotMinus1000 = function (v) {
  if (Math.abs(1000 + v) < 0.001) {
    return false;
  } else {
    return true;
  }
};
export const isFileExists = (path) => {
  return fs.existsSync(path);
};
export const fixStringNumber = (v, fixed) => {
  let fix = isDefined(fixed) ? fixed : 2;
  if (isDataValid(v)) {
    return parseFloat(v)._toFixed(fix);
  } else {
    return "--";
  }
};

export const isDataValid = (v) => {
  if (!isDefined(v)) return false;
  if (typeof v === "string" && isNumberString(v)) {
    if (v === "") return false;
    let val = parseFloat(v);
    return isDataNotMinus1000(val);
  } else if (typeof v === "number") {
    if (isNumNotNanOrInfinite(v) && isDataNotMinus1000(v)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
export const isNumNotNanOrInfinite = (v) => {
  return typeof v === "number" ? !isNaN(v) && isFinite(v) : false;
};
export const cartesian2polar = (x, y) => {
  let dist = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  let angle = (Math.atan2(y, x) * 180) / Math.PI;
  angle = angle < 0 ? 360 + angle : angle;
  return { dist, angle };
};
export const initArray = (num, fillval) => {
  let val = isDefined(fillval) ? fillval : INVALID_1000;
  let initArr = Array(num);
  initArr.fill(val);
  return initArr.concat();
};
export const forgeDeepCopy = (obj = {}) => {
  return JSON.parse(JSON.stringify(obj));
};
export const isCircleInCircle = (x, y, r, R) => {
  return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)) < Math.abs(R - r);
};
export const isPointInCircle = (x, y, radius) => {
  return Math.pow(x, 2) + Math.pow(y, 2) - Math.pow(radius, 2) < 0.01;
};

export const getFilePath = (casePath, file) => {
  return path.join(casePath, file);
};
let timerout;
export const stopWaiting = (self) => {
  clearTimeout(timerout);
  setTimeout(() => {
    self.$emit("input", false);
  }, 100);
};

export const calcImgSize = (container, oImage) => {
  let scaleW = container.width / oImage.width;
  let scaleH = container.height / oImage.height;
  let imgSize = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
  };
  if (scaleW > scaleH) {
    imgSize.width = oImage.width * scaleH;
    imgSize.height = container.height;
    imgSize.left = (container.width - imgSize.width) / 2;
  } else {
    imgSize.width = container.width;
    imgSize.height = oImage.height * scaleW;
    imgSize.top = (container.height - imgSize.height) / 2;
  }

  return imgSize;
};

export const calcZoomImg = (ev, zoom, posPre, posInit) => {
  const step = 0.1;
  let op = ev.deltaY > 0 ? -1 : 1;
  let _zoom = zoom;
  _zoom += op * step;
  if (ev.deltaY > 0) {
    if (_zoom <= 1) {
      return {
        left: posInit.left,
        top: posInit.top,
        zoom: 1
      };
    } else if (_zoom >= 2) {
      return {
        left: posPre.left,
        top: posPre.top,
        zoom: 2
      };
    }
  }
  posPre.left -= (ev.offsetX / zoom) * step * op;
  posPre.top -= (ev.offsetY / zoom) * step * op;
  return {
    left: posPre.left,
    top: posPre.top,
    zoom: _zoom
  };
};
export const getKeraColor = (value, mode) => {
  // const lang = window.settings.language === 'zh_CN' ? 'zh_CN' : 'en_US'
  // console.log('lang', lang)
  const threshold = window.keratoconusStd; // [lang]
  const th = threshold[mode];
  if (!isDataValid(value)) return "";
  if (Array.isArray(th)) {
    const v = parseFloat(value._toFixed(2));
    if (v < th[0]) {
      return "lightgreen";
    } else if (v >= th[0] && v <= th[1]) {
      return "#ff0";
    } else {
      return "#f00";
    }
  } else {
    return value <= th ? "green" : "red";
  }
};
export const getKeraLimits = (mode) => {
  const threshold = window.keratoconusStd; // [lang]
  const th = threshold[mode];
  if (Array.isArray(th)) {
    return [
      { label: "< " + th[0], color: "lightgreen" },
      { label: `${th[0]} ~ ${th[1]}`, color: "#ff0" },
      { label: "> " + th[1], color: "#f00" }
    ];
  } else {
    return [];
  }
};



// WEBPACK FOOTER //
// ./src/topography/shared/util.js